import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { api_url } from '../../utils/utils'

// ================= ADD =================
export const subCategoryAdd = createAsyncThunk(
  'subCategory/subCategoryAdd',
  async ({ name, category }, { rejectWithValue, fulfillWithValue, getState }) => {
    try {
      const token = getState().auth.token

      const { data } = await axios.post(
        `${api_url}/api/subcategory-add`,
        { name, category },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// ================= EDIT =================
export const subCategoryEdit = createAsyncThunk(
  'subCategory/subCategoryEdit',
  async ({ id, name, category }, { rejectWithValue, fulfillWithValue, getState }) => {
    try {
      const token = getState().auth.token

      const { data } = await axios.put(
        `${api_url}/api/subcategory-edit/${id}`,
        { id, name, category },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// ================= DELETE =================
export const subCategoryDelete = createAsyncThunk(
  'subCategory/subCategoryDelete',
  async (id, { rejectWithValue, fulfillWithValue, getState }) => {
    try {
      const token = getState().auth.token

      const { data } = await axios.delete(
        `${api_url}/api/subcategory-delete/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// ================= GET =================
export const get_subCategory = createAsyncThunk(
  'subCategory/get_subCategory',
  async (_, { rejectWithValue, fulfillWithValue, getState }) => {
    try {
      const token = getState().auth.token

      const { data } = await axios.get(
        `${api_url}/api/subcategory/get`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// ================= SLICE =================
const subCategoryReducer = createSlice({
  name: 'subCategory',
  initialState: {
    loader: false,
    successMessage: '',
    errorMessage: '',
    subCategorys: [],
    totalSubCategory: 0
  },
  reducers: {
    messageClear: (state) => {
      state.successMessage = ''
      state.errorMessage = ''
    }
  },
  extraReducers: {
    // ADD
    [subCategoryAdd.pending]: (state) => {
      state.loader = true
    },
    [subCategoryAdd.fulfilled]: (state, { payload }) => {
      state.loader = false
      state.successMessage = payload.message
      state.subCategorys.push(payload.subCategory)
    },
    [subCategoryAdd.rejected]: (state, { payload }) => {
      state.loader = false
      state.errorMessage = payload.error
    },

    // EDIT
    [subCategoryEdit.pending]: (state) => {
      state.loader = true
    },
    [subCategoryEdit.fulfilled]: (state, { payload }) => {
      state.loader = false
      state.successMessage = payload.message
    },
    [subCategoryEdit.rejected]: (state, { payload }) => {
      state.loader = false
      state.errorMessage = payload.error
    },

    // DELETE
    [subCategoryDelete.pending]: (state) => {
      state.loader = true
    },
    [subCategoryDelete.fulfilled]: (state, { payload }) => {
      state.loader = false
      state.successMessage = payload.message
      state.subCategorys = state.subCategorys.filter(c => c._id !== payload.id)
    },
    [subCategoryDelete.rejected]: (state, { payload }) => {
      state.loader = false
      state.errorMessage = payload.error
    },

    // GET
    [get_subCategory.fulfilled]: (state, { payload }) => {
      state.subCategorys = payload.subCategories || payload
      state.totalSubCategory = payload.totalSubCategory || payload.length
    }
  }
})

export const { messageClear } = subCategoryReducer.actions
export default subCategoryReducer.reducer
